<section class="mobile-app-section py-5">
  <div class="container">
    <div class="row text-center mb-4">
      <div class="col-12">
        <p class="eyebrow mb-2">Mobile</p>
        <h2 class="section-title">Members expect an app. You get two smart options.</h2>
        <p class="section-subtitle mx-auto">
          Give members a modern mobile experience with MemberTrace. Choose the shared MemberTrace app with your branding built in, or launch a fully custom branded app for your organization.
        </p>
      </div>
    </div>

    <div class="row justify-content-center mb-3" role="img"
         aria-label="Two mobile options: your organization inside MemberTrace, or your own app in the app stores.">
      <div class="col-12 col-lg-10">
        <div class="visual-comparison">
          <div class="visual-option">
            <div class="phone-glyph phone-glyph--shared">
              <span class="phone-notch"></span>
              <mat-icon class="glyph-icon">apps</mat-icon>
            </div>
            <p class="visual-label">Shared app</p>
            <p class="visual-hint">Your organization inside MemberTrace</p>
          </div>
          <div class="visual-vs" aria-hidden="true">or</div>
          <div class="visual-option">
            <div class="phone-glyph phone-glyph--custom">
              <span class="phone-notch"></span>
              <mat-icon class="glyph-icon">storefront</mat-icon>
            </div>
            <p class="visual-label">Custom app</p>
            <p class="visual-hint">Your own app in the stores</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-4 justify-content-center mb-4">
      <div class="col-md-6 col-lg-5">
        <mat-card class="highlight-card h-100">
          <mat-card-content class="p-4 text-center text-md-start">
            <mat-icon color="primary" class="card-icon mb-2">smartphone</mat-icon>
            <h3 class="card-title">Shared MemberTrace app</h3>
            <p class="card-copy mb-3">
              One download for members. Your organization appears inside the app with your logo and colors—no separate app build, launch, or maintenance required.
            </p>
            <a routerLink="/mobile" class="text-link">How the shared app works <mat-icon class="link-arrow">arrow_forward</mat-icon></a>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-6 col-lg-5">
        <mat-card class="highlight-card h-100">
          <mat-card-content class="p-4 text-center text-md-start">
            <mat-icon color="accent" class="card-icon mb-2">storefront</mat-icon>
            <h3 class="card-title">Custom branded apps</h3>
            <p class="card-copy mb-3">
              Launch a fully branded app in the App Store and Google Play, with scoped white-glove support for organizations that want a fully owned mobile presence.
            </p>
            <a routerLink="/mobile" fragment="custom-branded-apps" class="text-link">Explore custom apps <mat-icon class="link-arrow">arrow_forward</mat-icon></a>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <button mat-flat-button color="primary" routerLink="/mobile">Explore mobile options</button>
      </div>
    </div>
  </div>
</section>
